import React, { useEffect, useState, useRef, lazy, Suspense } from "react";
import { FaMicrophone, FaStop } from "react-icons/fa";
import AudioIcon from "../../../assets/icons/audio";
import VideoIcon from "../../../assets/icons/video";
import SendIcon from "../../../assets/icons/send.svg";
import { ReactComponent as MicIcon } from "../../../assets/icons/mic.svg";
import logoIcon from "../../../assets/icons/logo.svg";
import aipsychologistIcon from "../../../assets/icons/aipsychologist.svg";
import aidieticianIcon from "../../../assets/icons/aidietician.svg";
import insightsIcon from "../../../assets/icons/insights.svg";
import SlideOver from "../components/SlideOver";
import { useNavigate } from "react-router-dom";
import { OverlayService } from "../service/OverlayService";
import { AuthServices } from "../../auth/services/AuthServices";
import profilelogo from "../../../assets/icons/logo.svg";
import { formatToLocalDateFancy, formatToLocalDateTimeFancy, formatToLocalTimeFancy } from "../../../shared/utils/dateFormatter";
import {
  FiCopy,
   FiFileText, 
   FiMic, 
   FiVideo,
  FiThumbsUp,
  FiThumbsDown,
  FiVolume2,
  FiEdit,
  FiSmile,
  FiRefreshCw,
  FiChevronDown, // <-- needed for the floating arrow
  FiChevronUp,
  FiShare2,
} from "react-icons/fi";
import { FaThumbsUp,FaThumbsDown  } from "react-icons/fa";
import { handleShare } from "../../profile/pages/share";
import {  FaWhatsapp,
  FaFacebook, 
  FaLinkedinIn ,
  FaInstagram ,
  FaTelegram ,
  FaPinterest ,
  FaYahoo,
  FaShareAltSquare,
  FaReddit ,
  FaTumblrSquare ,
  FaSkype ,
  FaSnapchatSquare ,
  FaLink,

 } from "react-icons/fa";
 import { FaSquareXTwitter ,FaSquareThreads } from "react-icons/fa6";
 import { SiGmail } from "react-icons/si";
 import { PiMicrosoftOutlookLogoFill } from "react-icons/pi";


const InsightsPanel = lazy(() => import("../components/InsightsPanel"));
const JournalPanel = lazy(() => import("../components/JournalPanel"));
const MoodPanel = lazy(() => import("../components/Moodpanel"));

const userImg =localStorage.getItem("user")? JSON.parse(localStorage.getItem("user")).profile_picture : profilelogo;
console.log("User image:", userImg);
const FullScreenChat = ({
  handleModalOpen,
  isLoading,
  setIsLoading,
  addMessage,
  messagesEndRef,
  userInput,
  setUserInput,
  autoResize, // kept for compatibility
  sendMessage,
  messages,
  toggleRecording,
  showTyping,
  isRecording,
  chatHistory,
  selectedExpert, // coming from parent
  onExpertChange,
  setChatVisible,
}) => {
  const textareaRef = useRef(null);
  const [isOverflowFS, setIsOverflowFS] = useState(false);
  const baseHeightRef = useRef(null);

    const [showShareModal,setshowShareModal] = useState(false);
    const [showModal,setShowModal] = useState(false);
    const [insightTitle,setInsightTitle] = useState(false);
    const [insightBody,setInsightBody] = useState(false);

  // NEW: scroll-to-bottom arrow state/refs
  const messagesContainerRef = useRef(null);
  const navigate = useNavigate();

  const [showScrollBottom, setShowScrollBottom] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const messagesRef = useRef(null);
  const containerRef = useRef(null);
  const lastMessageRef = useRef(null);

const scrollToTop = () => {
  const el = messagesContainerRef.current;
  if (el) el.scrollTo({ top: 0, behavior: "smooth" });
};

  // slide-over
  const [panel, setPanel] = useState(null);
  const openPanel = (key) => setPanel(key);
  const closePanel = () => setPanel(null);

  // expert switch confirm
  const displayExpert = selectedExpert || "Expert";
  const [expertload, setexpertload] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [pendingExpert, setPendingExpert] = useState(null);

  const [isThinking, setIsThinking] = useState(true);

  const [chatFeedbacks, setChatFeedbacks] = useState({});
  const [retryingMsgs, setRetryingMsgs] = useState({});

  const handleSelectExpert = (expert) => {
    if (selectedExpert === expert) return;
    setPendingExpert(expert);
    setShowConfirmation(true);
  };
  // message formatting stays as-is
  const formatMessage = (text) => {
    if (!text) return null;
    return text.split(/<br\s*\/?>/i).map((line, i, arr) => (
      <React.Fragment key={i}>
        {line
          .split(/(<strong>.*?<\/strong>)/gi)
          .filter(Boolean)
          .map((part, j) => {
            if (/^<strong>.*<\/strong>$/i.test(part)) {
              return <strong key={j}>{part.replace(/<\/?strong>/gi, "")}</strong>;
            }
            return <React.Fragment key={j}>{part}</React.Fragment>;
          })}
        {i < arr.length - 1 && <br />}
      </React.Fragment>
    ));
  };

  const cleanText = (htmlText) => {
    if (!htmlText) return "";
    return htmlText.replace(/<br\s*\/?>/gi, "\n").replace(/<\/?strong>/gi, "");
  };

  const readAloud = (text) => {
    if (!text) return;
    window.speechSynthesis.cancel();
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "en-US";
    utterance.rate = 1;
    utterance.pitch = 1;
    window.speechSynthesis.speak(utterance);
  };

  function ChatFeedBack(feedback, msgid) {
    const rows = JSON.parse(localStorage.getItem("chat-feedback") || "[]");
    const existingIndex = rows.findIndex((row) => row.msgid === msgid);
    if (existingIndex !== -1) rows[existingIndex].feedback = feedback;
    else rows.push({ msgid, feedback });
    setChatFeedbacks((prev) => ({ ...prev, [msgid]: feedback }));
    localStorage.setItem("chat-feedback", JSON.stringify(rows));
    // updateChatFeedBack(feedback, msgid)
    saveFeedBack(feedback, msgid, 'chat_messages');
  }

  const saveFeedBack = async (feedback, id, tablename) => {
    try {
      const response = await OverlayService.saveFeedBack(feedback, id, tablename);
    } catch (err) {
      console.error("Error while saving:", err);
    }
  };

  function retrymsg(action, msgId) {
    setRetryingMsgs((prev) => ({ ...prev, [msgId]: true }));
    getRetryMsg(action, msgId);
    setTimeout(() => {
      setRetryingMsgs((prev) => {
        const updated = { ...prev };
        delete updated[msgId];
        return updated;
      });
    }, 2000);
  }


  const getRetryMsg = async (action, msgId) => {
    try {
      if (action === "retry") {
        await OverlayService.getRetryMsg(msgId);
        console.log("Message retried successfully:", msgId);
      }
    } catch (err) {
      console.error("Error retrying message:", err);
    }
  };

   const handleShareSocial = async (expert, keywords,body) => {
      
    const SelectedExpert = expert==='dietician' ? "Dietician" : "Therapist"; //"Psychologist";
    const keywordStr = String(keywords || "");  
    const formattedTags = keywordStr?.replace(/,/g, ",  ")||"";
    
      setInsightTitle('Message from Prashasync AI '+SelectedExpert);
      setInsightBody(body+'\n\nTags: '+formattedTags+'\n\n ** This message generated by Prashasync AI\n\n');
      setshowShareModal(true);

      //socialShare(title, body);
  };


  // can't submit while bot is busy, but typing is still allowed
  const isBusy = isLoading || isThinking || showTyping;

  // const handleSend = () => {
  //   const trimmed = userInput.trim();
  //   if (!trimmed) return;
  //   if (!trimmed || isBusy) return;
  //   addMessage(trimmed, "user");
  //   setUserInput("");
  //   setIsLoading(true);
  //   setIsThinking(true);
  //   sendMessage(trimmed, { mode: "text" });
  //   const el = textareaRef.current;
  //   if (el) {
  //     el.style.height = "auto";
  //     setIsOverflowFS(false);
  //   }
  // };

  const handleSend = () => {
    
    const trimmed = userInput.trim();
    if (!trimmed || isBusy) return;
    
    addMessage(trimmed, "user");
    setUserInput("");
    setIsLoading(true);
    setIsThinking(true);
    sendMessage(trimmed, { mode: "text" });
    const el = textareaRef.current;
    if (el) {
      el.style.height = "auto";
      setIsOverflowFS(false);
    }
    setTimeout(() => {
      scrollToBottom();
    }, 100);
  };

  const autoResizeInternal = () => {
    const el = textareaRef.current;
    if (!el) return;
    if (!el.value || !el.value.trim()) {
      el.style.height = `${baseHeightRef.current || 0}px`;
      setIsOverflowFS(false);
      return;
    }
    el.style.height = "auto";
    const cs = getComputedStyle(el);
    const maxH = parseFloat(cs.maxHeight);
    const maxPx = Number.isFinite(maxH) ? maxH : el.scrollHeight;
    el.style.height = `${Math.min(el.scrollHeight, maxPx)}px`;
    setIsOverflowFS(el.scrollHeight > el.clientHeight + 1);
  };

  // scroll helpers for the arrow
  const isNearBottom = (el) =>
    el.scrollHeight - el.scrollTop - el.clientHeight <= 50;
  const isNearTop = (el) => el.scrollTop <= 50;

  const handleScroll = () => {
    const el = messagesContainerRef.current;
    //const el = messagesRef.current;
    if (!el) return;
    setShowScrollBottom(!isNearBottom(el));
    setShowScrollTop(!isNearTop);
  };

  // Only auto-scroll if user is already near the bottom
  /*useEffect(() => {
    //const el = messagesContainerRef.current;
    const el = messagesRef.current;
    if (!el) return;
    const lastMessage = el.lastElementChild;
    if (lastMessage) {
     el.scrollTo({top: lastMessage.offsetTop,behavior: "smooth",});
     

    }

    // Check if user is near the bottom
  const nearBottom = isNearBottom(el); // you already have this function
  console.log("nearBottm",nearBottom);
  setShowScrollBottom(!nearBottom); // show arrow if user is not at bottom

    if (isNearBottom(el)) {
      messagesEndRef?.current?.scrollIntoView({ behavior: "smooth" });
      setShowScrollBottom(false);
    } else {
      setShowScrollBottom(true);
    }
  }, [messagesEndRef, messages?.length]); // trigger when new message count changes
*/

// scroll to bottom when messages change
  useEffect(() => {

    if (lastMessageRef.current && messagesContainerRef.current) {
      const container = messagesContainerRef.current;
      const lastMessage = lastMessageRef.current;

      // Force align last message's top to container's top
      container.scrollTop = lastMessage.offsetTop - container.offsetTop;
    }
    
    
  }, [messagesEndRef,messages]);

const lastScrollTop = useRef(0);
const hideTopTimer = useRef(null);

useEffect(() => {
  const handleScroll = () => {
    const el = messagesContainerRef.current;
    if (!el) return;

    const nearBottom = el.scrollHeight - el.scrollTop - el.clientHeight <= 50;
    const scrollingUp = el.scrollTop < lastScrollTop.current;
    lastScrollTop.current = el.scrollTop;

    // Show scroll-to-top if user scrolls up and not at bottom
    if (!nearBottom && scrollingUp) {
      setShowScrollTop(true);

      // Reset the hide timer
      if (hideTopTimer.current) clearTimeout(hideTopTimer.current);
      hideTopTimer.current = setTimeout(() => {
        setShowScrollTop(false);
      }, 3000); // hide after 3s of inactivity
    } else if (nearBottom) {
      setShowScrollTop(false);
      if (hideTopTimer.current) clearTimeout(hideTopTimer.current);
    }

    // Show scroll-to-bottom when not near bottom
    setShowScrollBottom(!nearBottom);
  };

  const el = messagesContainerRef.current;
  if (el) el.addEventListener("scroll", handleScroll);
  return () => {
    if (el) el.removeEventListener("scroll", handleScroll);
    if (hideTopTimer.current) clearTimeout(hideTopTimer.current);
  };
}, []);

  // keep textarea scrolled to bottom as it grows (unchanged)
  useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = "";
    const cs = getComputedStyle(el);
    const minH =
      parseFloat(cs.minHeight) ||
      (parseFloat(cs.lineHeight) || 20) +
      (parseFloat(cs.paddingTop) || 0) +
      (parseFloat(cs.paddingBottom) || 0);
    baseHeightRef.current = minH;
    el.style.height = `${minH}px`;
    setIsOverflowFS(false);
  }, []);

  useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;
    const handleAutoScroll = () => {
      el.scrollTop = el.scrollHeight;
    };
    el.addEventListener("input", handleAutoScroll);
    return () => el.removeEventListener("input", handleAutoScroll);
  }, []);

  // normalize messages (unchanged)
  const historyArray = Array.isArray(chatHistory)
    ? chatHistory
    : chatHistory?.messages || [];

  // const historyMsgs = historyArray.map((m, idx) => ({
  //   const sender = (m.sender_id === process.env.REACT_APP_DIETITIAN || m.sender_id === process.env.REACT_APP_PSYCHOLOGIST || m.sender_id === 'system') ? 'ai' : 'user';
  //   id: m.chat_message_id,
  //   sender: sender ? ,
  //   text: m.text ?? m.message_text ?? "",
  //   receiver: m.receiver_id,
  //   timestamp: m.timestamp ?? m.createdat ?? null,
  //   expert: JSON.parse(m.extracted_keywords)?.persona
  // }));

  const historyMsgs = historyArray.map((m, idx) => {
    const sender = (
                    m.sender_id === process.env.REACT_APP_DIETITIAN ||
                    m.sender_id === process.env.REACT_APP_PSYCHOLOGIST ||
                    m.sender_id === "system"
                  ) ? "ai" : "user";

    let expert = null;
    let chatMode = null;
    let keywords = [];
    

    if (m.extracted_keywords) {
      try {
        const parsed = JSON.parse(m.extracted_keywords);
        expert = parsed?.persona || null;
        chatMode = parsed?.chat_mode || null;
        keywords = parsed?.keywords || [];
      } catch (e) {
        expert = null;
        chatMode = null;
        keywords = [];
      }
    }

    return {
      id: m.chat_message_id,
      sender: sender,
      text: m.text ?? m.message_text ?? "",
      receiver: m.receiver_id,
      timestamp: m.createdat ?? null,
      expert: expert,
      chatMode: chatMode,
      feedback: m.feedback,
      keywords: keywords,
      issummary : m.sender_id === "system"? true : false,
    };
  });

  /*const lastMessage = historyMsgs.at(-1);
  lastMessage?.expert && console.log("Last message expert:", lastMessage.expert);
  if (!expertload && selectedExpert !== lastMessage?.expert && typeof onExpertChange === "function") {
                onExpertChange(lastMessage?.expert);
                setexpertload(true);
              
      }*/

  const localMsgs = Array.isArray(messages) ? messages : [];
  console.log("Local messages:", localMsgs);
  const combinedMessages = [...historyMsgs, ...localMsgs];

  const isExpertMessage = (msg) => {
    const raw = msg?.sender;
    const s = String(raw ?? "").toLowerCase();
    const expertIds = [
      process.env.REACT_APP_DIETITIAN,
      process.env.REACT_APP_PSYCHOLOGIST,
    ]
      .filter(Boolean)
      .map(String);
    return (
      s === "ai" ||
      s === "assistant" ||
      s === "expert" ||
      s === "doctor" ||
      s === "dietician" ||
      expertIds.includes(String(raw))
    );
  };

  /*const scrollToBottom = () => {
    messagesEndRef?.current?.scrollIntoView({ behavior: "smooth" });
    const el = messagesContainerRef.current;
    if (el) setShowScrollBottom(!isNearBottom(el));
  };*/

const scrollToBottom = () => {
  messagesContainerRef.current?.scrollTo({
    top: messagesContainerRef.current.scrollHeight,
    behavior: "smooth"
  });
};

  // === Summary prompt (every 5 expert replies) ===
  const SUMMARY_EVERY = 5;

  const [replyCount, setReplyCount] = useState(
    Number(localStorage.getItem("expertReplyCount") || 0)
  );
  const [showSummaryPrompt, setShowSummaryPrompt] = useState(false);
  const [isSummarizing, setIsSummarizing] = useState(false);
  const [summaryText, setSummaryText] = useState("");

  // keep last counted expert message id so we don't double count on re-renders
  const lastCountedIdRef = useRef(localStorage.getItem("lastCountedMsgId") || null);

  const resetReplyCounter = () => {
    setReplyCount(0);
    localStorage.setItem("expertReplyCount", "0");
    lastCountedIdRef.current = null;
    localStorage.removeItem("lastCountedMsgId");
  };

  // strip <br>, <strong>, and any other tags; compress whitespace
  const plain = (s = "") =>
    s
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/?strong>/gi, "")
      .replace(/<[^>]+>/g, "")
      .replace(/\s+/g, " ")
      .trim();

  const bumpReplyCount = (msgId) => {
    // avoid recounting the same message
    if (String(lastCountedIdRef.current) === String(msgId)) return;
    lastCountedIdRef.current = String(msgId);
    localStorage.setItem("lastCountedMsgId", String(msgId));

    setReplyCount((prev) => {
      const next = prev + 1;
      localStorage.setItem("expertReplyCount", String(next));

      // show only at 5, 10, 15, ...
      if (next % SUMMARY_EVERY === 0) {
        setSummaryText("");
        setShowSummaryPrompt(true);
      }
      return next;
    });
  };

  // when a NEW expert message lands, bump the counter
  useEffect(() => {
    if (!combinedMessages?.length) return;
    const last = combinedMessages[combinedMessages.length - 1];
    if (!isExpertMessage(last)) return;
    bumpReplyCount(last.id ?? combinedMessages.length - 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [combinedMessages.length]);

  // quick client-side summary of recent turns (replace with API call later if you want)
  async function generateSummary() {
    setIsSummarizing(true);
    try {
      //const conversationsummary = {summary_data: {summary: ""}};
      let displaysummary = "";
      const patient_id = JSON.parse(localStorage.getItem("user"))?.patient_id;
      const conversation_id = localStorage.getItem("conversation_id");
      const current_persona = selectedExpert || "psychologist";
      if (patient_id) {
        const conversationsummary = await AuthServices.generateSummaryApi(patient_id, conversation_id, current_persona);
        if (conversationsummary.status !== 200) {
          console.error("Error generating insights:", conversationsummary);
        }
        displaysummary = conversationsummary.data.summary_data.summary;
        //displaysummary+="\n\nRecommandation:\n\n"+conversationsummary.data.key_recommendations
        //return conversationsummary;
      }
      // take last ~6 messages, flatten text
      const recent = [...combinedMessages].slice(-6);
      const points = recent
        .map((m) => {
          const who = isExpertMessage(m) ? "Expert" : "You";
          const txt = plain(m.text || "");
          return txt ? `${who}: ${txt}` : "";
        })
        .filter(Boolean);
      const bullets = points.map((p) => `• ${p}`).join("\n");
      setSummaryText(`Here’s a quick recap:\n\n${displaysummary || bullets}`);
    } catch (e) {
      console.error(e);
      setSummaryText("Sorry—couldn’t generate a summary right now.");
    } finally {
      setIsSummarizing(false);
      resetReplyCounter(); // require another 5 replies before showing again
    }
  }


  // -- Idle modal state
  const [showIdleModal, setShowIdleModal] = useState(false);

  useEffect(() => {
    const INACTIVE_MS = 10 * 60 * 1000; // 10MINUTES
    const POLL_MS = 1_000;      // check every second
    const KEY = "lastActivityAt";

    const stamp = () => {
      if (showIdleModal) return; // ⛔ don't close modal on activity
      localStorage.setItem(KEY, String(Date.now()));
    };

    // seed once
    if (!localStorage.getItem(KEY)) stamp();

    // listen ONLY when modal is not shown
    const events = ["click", "keydown", "mousemove", "touchstart", "scroll"];
    if (!showIdleModal) {
      events.forEach((e) => window.addEventListener(e, stamp, { passive: true }));
    }

    // visibility acts as activity only when modal is not shown
    const onVis = () => { if (!document.hidden && !showIdleModal) stamp(); };
    document.addEventListener("visibilitychange", onVis);

    // poll ONLY when modal is not shown
    let poll = null;
    if (!showIdleModal) {
      poll = setInterval(() => {
        const last = Number(localStorage.getItem(KEY) || 0);
        if (!last) return stamp();
        if (Date.now() - last >= INACTIVE_MS) setShowIdleModal(true);
      }, POLL_MS);
    }

    return () => {
      events.forEach((e) => window.removeEventListener(e, stamp));
      document.removeEventListener("visibilitychange", onVis);
      if (poll) clearInterval(poll);
    };
  }, [showIdleModal]);

  // the ONLY ways to close it:
  const handleStayActive = () => {
    localStorage.setItem("lastActivityAt", String(Date.now()));
    setShowIdleModal(false);
  };

  const handleEndSession = () => {
    //localStorage.removeItem("conversation_id");
    setShowIdleModal(false);
    setChatVisible(false);
    
    //navigate("/");
    //window.location.reload();
  };
  // Handle when loading completes to hide thinking dots
  useEffect(() => {
    if (!isLoading) {
      setIsThinking(false);
    }
  }, [isLoading]);


   /*useEffect(() => {
      setIsThinking(true);
    }, []);*/
  

  const [user] = useState(() => {
    try { return JSON.parse(localStorage.getItem("user") || "null"); }
    catch { return null; }
  });
  const userName =
    (user?.first_name || user?.last_name)
      ? `${user?.first_name ?? ""} ${user?.last_name ?? ""}`.trim()
      : user?.name || user?.email?.split("@")[0] || "You";

  return (
    <div className="chat-fullscreen">
      {/* Messages */}
      <div
        className="chat-messages"
        ref={messagesContainerRef}
        onScroll={handleScroll}
      >
        {combinedMessages.map((msg) => {
          const isExpert = isExpertMessage(msg);
          // Determine the current chat mode
const chatMode = msg.chatMode || localStorage.getItem("chat_mode") || "text";

// ChatModeIcon component
const ChatModeIcon = ({ mode }) => {
  switch (mode.toLowerCase()) {
    case "text":
      return (
        <span title="Text Mode">
          <FiFileText size={10} />
        </span>
      );
    case "audio":
      return (
        <span title="Audio Mode">
          <FiMic size={10} />
        </span>
      );
    case "video":
      return (
        <span title="Video Mode">
          <FiVideo size={10} />
        </span>
      );
    default:
      return (
        <span title="Text Mode">
          <FiFileText size={10} />
        </span>
      );
  }
};
          console.log("isExpert, Message:", isExpert, msg);
          
          return (
            <React.Fragment key={msg.id}>
              <div
              ref={msg.id === combinedMessages[combinedMessages.length - 1].id ? lastMessageRef : null}
              ></div>
              {isExpert && (
                <h3 className="ai-response-title">
                    <img src={logoIcon} alt="AI Logo" className="profile-pic" style={{width:"20px",height:"20px", marginRight: "0px"}} />
                  { msg.issummary? "Expert Summary"
                     : msg.expert === "dietician"
                     ? "Dietician"
                      : msg.expert === "psychologist"
                      ? "Therapist"//"Psychologist"
                       : msg.expert
                  }
                 
                    <small style={{ textTransform: "capitalize", color: "#666", fontSize: "13px" }}>
                      |&nbsp;<ChatModeIcon mode={chatMode} /> 
                      
                    </small>
                  
                </h3>
              )}
              {!isExpert && (
                <h3 className="user-response-title" style={{ textAlign: "right" }}>
                  <img src={userImg? userImg : profilelogo} alt="profile" className="profile-pic" style={{width:"20px",height:"20px", marginRight: "8px"}}/>
                  {userName}&nbsp;&nbsp;
                  
                    <small style={{ textTransform: "capitalize", color: "#666", fontSize: "13px" }}>
                       |&nbsp;<ChatModeIcon mode={chatMode} /> 
                    </small>
                 
                </h3>
              )}

              <div className={`chat-bubble ${msg.issummary? "expert-message-summary" : isExpert ? "expert-message" : "user-message"}`}
              
              >
                <div>
                  {retryingMsgs[msg.id] ? (
                    <i style={{ color: "gray" }}>Retrying to load...</i>
                  ) : (
                    String(msg.text || "")
                      .split("\n")
                      .map((line, i) => <div key={i}
                      ref={i >= messages.length - 1 ? lastMessageRef : null}
                      
                      >{formatMessage(line)}</div>)
                  )}
                </div>
                {msg.keywords && msg.keywords.length > 0 && (
                  <div className="message-keywords">
                    {msg.keywords.map((kw, idx) => (
                      <span key={idx} className="keyword-badge">
                        {kw}
                      </span>
                    ))}
                  </div>
                )}

                {msg.timestamp && (
                  <div className="timestamp">
                    {new Date(msg.timestamp).toLocaleString()}
                  </div>
                )}
              </div>

              {/* 7-icon row under expert message */}
              {isExpert && (
                <div
                  className="msg-actions"
                  style={{
                    display: "flex",
                    gap: 10,
                    alignItems: "center",
                    marginTop: 8,
                    marginBottom: 8,
                    flexWrap: "wrap",
                    color: "#7c8894",
                  }}
                >
                  <button
                    className="msg-action-btn"
                    title="Copy"
                    aria-label="Copy"
                    onClick={() => navigator.clipboard?.writeText(cleanText(msg.text) || "")}
                    style={btnStyle}
                  >
                    <FiCopy />
                  </button>

                  {/* {chatFeedbacks[msg.id] !== "ThumbsDown" && ( */}
                  <button
                    className="msg-action-btn"
                    title="ThumbsUp"
                    aria-label="ThumbsUp"
                    onClick={() => ChatFeedBack("ThumbsUp", msg.id)}
                    style={btnStyle}
                  >
                    <FaThumbsUp color={chatFeedbacks[msg.id] === "ThumbsUp" || msg.feedback === "ThumbsUp" ? "green" : "inherit"} />
                  </button>
                  {/* )} */}

                  {/* {chatFeedbacks[msg.id] !== "ThumbsUp" && ( */}
                  <button
                    className="msg-action-btn"
                    title="ThumbsDown"
                    aria-label="ThumbsDown"
                    onClick={() => ChatFeedBack("ThumbsDown", msg.id)}
                    style={btnStyle}
                  >
                    <FaThumbsDown color={chatFeedbacks[msg.id] === "ThumbsDown" || msg.feedback === "ThumbsDown" ? "red" : "inherit"} />
                  </button>
                  {/* )} */}

                  <button
                    className="msg-action-btn"
                    title="Read aloud"
                    aria-label="TTS"
                    onClick={() => readAloud(cleanText(msg.text))}
                    style={btnStyle}
                  >
                    <FiVolume2 />
                  </button>
                  <button
                    className="msg-action-btn"
                    title="Edit journal"
                    aria-label="Edit journal"
                    onClick={() => openPanel("journal")}
                    style={btnStyle}
                  >
                    <FiEdit />
                  </button>
                  <button
                    className="msg-action-btn"
                    title="Mood tracker"
                    aria-label="Mood tracker"
                    onClick={() => openPanel("mood")}
                    style={btnStyle}
                  >
                    <FiSmile />
                  </button>
                  <button
                    className="msg-action-btn"
                    title="Share"
                    aria-label="Share"
                    onClick={() => handleShareSocial(msg.expert,msg.keywords,msg.text)}
                    style={btnStyle}
                  >
                    <FiShare2 />
                  </button>
                  <button
                    className="msg-action-btn"
                    title="Retry"
                    aria-label="Retry"
                    onClick={() => retrymsg("retry", msg.id)}
                    style={btnStyle}
                  >
                    <FiRefreshCw />
                  </button>
                </div>
              )}
            </React.Fragment>
          );
        })}
        {isLoading && (
          <div className="chat-bubble expert-message">
            <div className="loading-dots">
              <span>Thinking.</span>
              <span>.</span>
              <span>.</span>
              <span>.</span>
            </div>
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>



      {/* Input + controls */}
      <div className="chat-bottom-container">
        <div className="input-box">
          <textarea
            ref={textareaRef}
            className={`chat-textarea ${isOverflowFS ? "is-scrolling" : ""}`}
            placeholder={`Ask Your ${displayExpert==='psychologist'? 'Therapist' : 'Dietician'}`}
            value={userInput}
            onChange={(e) => {
              setUserInput(e.target.value);
              autoResizeInternal();
              if (typeof autoResize === "function") autoResize(e);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                if (!isBusy) handleSend();
              }
            }}
                    
            rows={1}
          />
          {/* Floating scroll-to-bottom arrow */}

           {showScrollTop && (
  <button
    className="scroll-btn scroll-to-top"
    onClick={scrollToTop}
    aria-label="Scroll to top"
  >
    <FiChevronUp size={20} />
  </button>
)}


          {showScrollBottom && (
            <button
              className="scroll-to-bottom"
              onClick={scrollToBottom}
              aria-label="Scroll to latest"
            >
              <FiChevronDown size={20} />
            </button>
          )}

         
        </div>

        <div className="chat-controls-row">
          {/* Psychologist */}
          {/* <button
            className={`icon-btn icon-btn--white ${displayExpert === "psychologist" ? "active" : ""}`}
            onClick={() => handleSelectExpert("psychologist")}
            aria-label="AI Psychologist"
            title="Psychologist"
          >
            <img src={aipsychologistIcon} alt="Psychologist" width={24} height={24} />
          </button> */}
          <button
            className={`icon-btn icon-btn--white ${displayExpert === "psychologist" ? "active" : ""}`}
            onClick={() => {
              if (selectedExpert !== "psychologist" && typeof onExpertChange === "function") {
                onExpertChange("psychologist");
              }
            }}
            aria-label="AI Therapist" //"AI Psychologist"
            title="Therapist" //"Psychologist"
          >
            <img src={aipsychologistIcon} alt="Therapist" width={24} height={24} />
          </button>

          {/* Dietician */}
          {/* <button
            className={`icon-btn icon-btn--white ${displayExpert === "dietician" ? "active" : ""}`}
            onClick={() => handleSelectExpert("dietician")}
            aria-label="AI Dietician"
            title="Dietician"
          >
            <img src={aidieticianIcon} alt="Dietician" width={24} height={24} />
          </button> */}
          <button
            className={`icon-btn icon-btn--white ${displayExpert === "dietician" ? "active" : ""}`}
            onClick={() => {
              if (selectedExpert !== "dietician" && typeof onExpertChange === "function") {
                onExpertChange("dietician");
              }
            }}
            aria-label="AI Dietician"
            title="Dietician"
          >
            <img src={aidieticianIcon} alt="Dietician" width={24} height={24} />
          </button>

          {/* Mic */}
          <button
            onClick={toggleRecording}
            disabled={showTyping}
            className="icon-btn icon-btn--white"
            aria-label={isRecording ? "Stop recording" : "Start recording"}
            title={isRecording ? "Stop recording" : "Start recording"}
          >
            {isRecording ? <FaStop /> : <MicIcon />}
          </button>

          {/* Audio/Video */}
          <button
            className="icon-btn icon-btn--primary"
            onClick={() => handleModalOpen("audio")}
            aria-label="Audio"
            title="Audio"
          >
            <AudioIcon width={20} height={20} />
          </button>
          <button
            className="icon-btn icon-btn--primary"
            onClick={() => handleModalOpen("video")}
            aria-label="Video"
            title="Video"
          >
            <VideoIcon width={20} height={20} />
          </button>

          {/* Send */}
          <button
            className="icon-btn icon-btn--primary send-btn"
            onClick={handleSend}
            disabled={isBusy || !userInput || !userInput.trim()}
            aria-label="Send"
            title="Send"
          >
            <img src={SendIcon} alt="Send" width={20} height={20} />
          </button>
        </div>
      </div>

      {/* SlideOver */}
      <SlideOver
        title={
          panel === "insights"
            ? "Insights"
            : panel === "mood"
              ? "Mood"
              : panel === "journal"
                ? "Journal"
                : ""
        }
        isOpen={!!panel}
        onClose={closePanel}
      >
        {panel && (
          <Suspense fallback={<div>Loading…</div>}>
            {panel === "insights" && <InsightsPanel onClose={closePanel} />}
            {panel === "journal" && <JournalPanel onClose={closePanel} />}
            {panel === "mood" && <MoodPanel onClose={closePanel} />}
          </Suspense>
        )}
      </SlideOver>

      {/* Confirmation */}
      {showConfirmation && (
        <div className="chat-confirmation-overlay">
          <div className="chat-confirmation-box">
            <h4>Confirmation</h4>
            <p>
              Ending current session. Starting session with the{" "}
              <strong>{pendingExpert}</strong>.
            </p>
            <div className="chat-confirmation-buttons">
              {/* <button
                className="outline-btn"
                onClick={() => {
                  if (typeof onExpertChange === "function") {
                    onExpertChange(pendingExpert);
                  }
                  setShowConfirmation(false);
                }}
              >
                Start New
              </button> */}
              <button
                className="outline-btn"
                onClick={() => {
                  const newExpert =
                    selectedExpert === "dietician" ? "psychologist" : "dietician";

                  if (typeof onExpertChange === "function") {
                    onExpertChange(newExpert);
                  }

                  setShowConfirmation(false);
                }}
              >
                Start New
              </button>

              <button
                className="filled-btn"
                onClick={() => setShowConfirmation(false)}
              >
                Stay
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Summary mini-dialog */}
      {showSummaryPrompt && (
        <div
          style={{
            position: "fixed",
            right: "0px",
            left: "16px",
            bottom: "110px", // sits above input row
            zIndex: 9999,
            width: "95%",
            height: "auto",
            maxWidth: "93.5vw",
            background: "#fff",
            //border: "1px solid #e5e7eb",
            //borderRadius: 12,
            //boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
            padding: "0px",
            fontFamily: "Inter, system-ui, sans-serif",
          }}
        >
          {!summaryText ? (
            <>
              <div style={{ fontWeight: 600, marginBottom: 6 }}>
                Generate a quick summary?
              </div>
              <div style={{ fontSize: 13, color: "#556170", marginBottom: 12 }}>
                You’ve received a few replies. Want a short recap?
              </div>
              <div style={{ display: "flex", gap: 100, justifyContent: "center" }}>
                <button
                  className="cancel"
                  onClick={() => {
                    resetReplyCounter();
                    setShowSummaryPrompt(false);
                  }}
                  style={{
                    border: "1px solid #d1d5db",
                    background: "transparent",
                    borderRadius: 10,
                    padding: "5px 50px",
                    fontSize: 13,
                    color: "#374151",
                    cursor: "pointer",
                  }}
                >
                  No
                </button>
                <button
                  className="done"
                  onClick={generateSummary}
                  disabled={isSummarizing}
                  style={{
                    background: "#7d6bea",
                    color: "#fff",
                    border: "none",
                    borderRadius: 10,
                    padding: "5px 40px",
                    fontSize: 13,
                    cursor: "pointer",
                    opacity: isSummarizing ? 0.6 : 1,
                  }}
                >
                  {isSummarizing ? "Summarizing…" : "Yes"}
                </button>
              </div>
            </>
          ) : (
            <>
              <div style={{ fontWeight: 600, marginBottom: 8 }}>Summary</div>
              <pre
                style={{
                  whiteSpace: "pre-wrap",
                  background: "#f8fafc",
                  border: "1px solid #eef2f7",
                  padding: 10,
                  borderRadius: 8,
                  maxHeight: "auto",
                  overflow: "auto",
                  fontSize: 12.5,
                  lineHeight: 1.35,
                  color: "#111827",
                  
                }}
              >

                {summaryText}
              </pre>
              <div style={{ display: "flex", justifyContent: "center", marginTop: 25 }}>
                <button
                  className="done"
                  onClick={() => {
                    setShowSummaryPrompt(false);
                    setSummaryText("");
                  }}
                  style={{
                    background: "#7d6bea",
                    color: "#fff",
                    border: "none",
                    borderRadius: 20,
                    padding: "6px 60px",
                    fontSize: 20,
                    cursor: "pointer",
                  }}
                >
                  Close
                </button>
              </div>
            </>
          )}
        </div>
      )}



{/* Share Modal */}
{showShareModal && (
  <div
    className="bottomSlide-modal-overlay"
    onClick={() => setshowShareModal(false)}
  >
    <div
      className="bottomSlide-modal"
      
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className="modal-close-xlogin"
        aria-label="Close modal"
        onClick={() => setshowShareModal(false)}
      >
        ×
      </button>

      <div className="modal-header-login">
        <h3 style={{ textAlign: "center", marginBottom: "15px" }}>
          Share PraSha Sync
        </h3>
      </div>
      <hr style={{ marginBottom: "20px" }} />

      <div
        className="share-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(80px, 1fr))",
          gap: "25px",
          justifyItems: "center",
          alignItems: "center",
          flex: 1,
          overflowY: "auto",
          padding: "10px",
          background: "transparent",
        }}
      >
        {[
          { channel: "copy", icon: <FaLink size={40} color="gray" />, label: "Copy URL"},
          { channel: "whatsapp", icon: <FaWhatsapp size={40} color="#25D366" />, label: "WhatsApp" },
          { channel: "gmail", icon: <SiGmail size={40} color="#EA4335" />, label: "Gmail" },
          { channel: "yahoo", icon: <FaYahoo size={40} color="#720E9E" />, label: "Yahoo" },
          { channel: "outlook", icon: <PiMicrosoftOutlookLogoFill size={40} color="#0072C6" />, label: "Outlook" },
          { channel: "instagram", icon: <FaInstagram size={40} color="#E1306C" />, label: "Instagram" },
          { channel: "facebook", icon: <FaFacebook size={40} color="#1877F2" />, label: "Facebook" },
          { channel: "linkedin", icon: <FaLinkedinIn size={40} color="#0A66C2" />, label: "LinkedIn" },
          { channel: "twitter", icon: <FaSquareXTwitter size={40} color="black" />, label: "Twitter" },
          { channel: "telegram", icon: <FaTelegram size={40} color="#0088cc" />, label: "Telegram" },
          { channel: "pinterest", icon: <FaPinterest size={40} color="#E60023" />, label: "Pinterest" },
          { channel: "reddit", icon: <FaReddit size={40} color="#FF4500" />, label: "Reddit" },
          { channel: "tumblr", icon: <FaTumblrSquare size={40} color="#35465C" />, label: "Tumblr" },
          { channel: "skype", icon: <FaSkype size={40} color="#00AFF0" />, label: "Skype" },
          { channel: "snapchat", icon: <FaSnapchatSquare size={40} color="#FFFC00" />, label: "Snapchat" },
          { channel: "threads", icon: <FaSquareThreads size={40} color="black" />, label: "Threads" },
          { channel: "system", icon: <FaShareAltSquare size={40} color="gray" />, label: "System" },
        ].map(({ channel, icon, label }) => (
          <button
            key={channel}
            onClick={() => handleShare({ channel,"text":insightBody,"title":insightTitle})}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "6px",
              background: "transparent",
              border: "none",
              cursor: "pointer",
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: "50%",
                padding: "12px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                transition: "transform 0.2s",
              }}
              className="icon-button"
            >
              {icon}
            </div>
            <span style={{ fontSize: "12px", color: "#555" }}>{label}</span>
          </button>
        ))}
      </div>

      <button
        className="modal-close-btnlogin"
        style={{ marginTop: "20px", display:"none" }}
        onClick={() => setshowShareModal(false)}
      >
        Close
      </button>
    </div>
  </div>
)}



      {showIdleModal && (
        <div className="voice-modal-overlay">
          <div className="voice-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header-indicator" />
            <h3 style={{ fontWeight: 600, marginBottom: 6 }}>Still there?</h3>
            <p style={{ marginBottom: 14 }}>You’ve been inactive for a while.</p>
            <div className="modal-actions">
              <button className="cancel" onClick={handleStayActive}>Stay</button>
              <button className="done" onClick={handleEndSession}>End Session</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// visible even if CSS isn’t loaded yet
const btnStyle = {
  border: 0,
  background: "transparent",
  padding: 6,
  lineHeight: 0,
  borderRadius: 8,
  cursor: "pointer",
};

export default FullScreenChat;
